import React, { useState } from "react";
import { Modal, Button } from "antd";

const useSuccessErrorModal = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalMessage, setModalMessage] = useState("");
  const [onModalOk, setOnModalOk] = useState(() => () => {});

  const showModal = (title, message, onOk) => {
    if (title?.includes("cancel") || message?.includes("cancel")) {
      return;
    }
    setModalTitle(title);
    setModalMessage(message);
    setOnModalOk(() => onOk);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const ModalComponent = () => (
    <Modal
      title={modalTitle}
      open={modalOpen}
      centered
      closable={false}
      onOk={onModalOk}
      footer={[
        <Button key="ok" onClick={onModalOk}>
          OK
        </Button>,
      ]}
    >
      <div style={{ whiteSpace: "pre-wrap" }}>{modalMessage}</div>
    </Modal>
  );

  return {
    showModal,
    closeModal,
    ModalComponent,
  };
};

export default useSuccessErrorModal;
